import { render, staticRenderFns } from "./PromotionsDrawer.vue?vue&type=template&id=23f53300&scoped=true&"
import script from "./PromotionsDrawer.vue?vue&type=script&lang=ts&"
export * from "./PromotionsDrawer.vue?vue&type=script&lang=ts&"
import style0 from "./PromotionsDrawer.vue?vue&type=style&index=0&id=23f53300&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23f53300",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AtomsKEButton: require('/var/www/packages/theme/components/atoms/KEButton.vue').default,AtomsKEDrawer: require('/var/www/packages/theme/components/atoms/KEDrawer.vue').default})
